// removed by extract-text-webpack-plugin
module.exports = {"fadeInUp":"frontend__fadeInUp___10JDh","fadeInDown":"frontend__fadeInDown___qcKVm"};


//////////////////
// WEBPACK FOOTER
// ./css/frontend.scss
// module id = 251
// module chunks = 4